module.exports = __webpack_public_path__ + "img/LamdeiniLearning-4.e59792cd.jpg";